import {
    IonContent,
    IonLabel,
    IonNote
} from '@ionic/react';
import React from 'react';
import './Users.css';
import {useSelector} from "react-redux";
import LogoutButton from "../components/LogoutButton";
import {RootState} from "../store";
import AdminButton from "../components/admin/AdminButton";

const Profile: React.FC = () => {
    const user = useSelector((state: RootState) => state.authenticated.googleUser)

    if (!user) {
        return <></>
    }

    return (
        <IonContent>
            <div className="profile-overview">
                <div className={"profile-picture"}>
                    <img src={user?.photoURL ?? ''} alt={user?.email!} />
                </div>
                <IonLabel>{user?.displayName}</IonLabel>
                <IonNote>{user?.email}</IonNote>

                <AdminButton />
                <LogoutButton />
            </div>
        </IonContent>
    )
}

export default Profile;
